// Module
var code = `<section class="page-hero-container">
  <!--  <div class="callout">
      <section class="gradient-wrapper">
        <h1>{{title}}</h1>
        <p>{{desc}}</p>
      </section>
    </div>

    <figure class="bg-image">
      <img src="{{imgUrl}}" alt="{{alt}}" />
    </figure>-->
</section>


<section class="page-body default-content">

<section class="features">
  <!--<div class="feature-card">
    <h2>Feature One</h2>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin fermentum
      neque ut vehicula cursus.
    </p>
  </div>
  <div class="feature-card">
    <h2>Feature Two</h2>
    <p>
      Nullam dapibus quis justo at rutrum. Etiam efficitur lorem a dapibus
      convallis.
    </p>
  </div>
  <div class="feature-card">
    <h2>Feature Three</h2>
    <p>
      Vestibulum non commodo eros. Phasellus tempus lectus ut urna pulvinar
      rutrum.
    </p>
  </div>-->
</section>
</section>
`;
// Exports
module.exports = code;